import { Directive, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[formControlName][appAlphanumeric]',
  standalone: false
})
export class AlphanumericDirective {
  ngControl = inject(NgControl);

  constructor() { }

  @HostListener('ngModelChange', ['$event'])
  onModelChange($event) {
    this.onInputChange($event);
  }

  private onInputChange($event): void {
    const newVal = $event?.replace(/[^a-zA-Z0-9]*/g, '') ?? '';

    this.ngControl.valueAccessor.writeValue(newVal);
  }
}
